export default __webpack_public_path__ + "static/135-aac5b7d762eb120a75cfad1aa82188fd.jpg";